<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :class="isIconDisabled ? 'disabled disabled-icon' : ''"
    @click="createCompilationHandler()"
  >
    <BaseSpriteIcon icon-name="ico-extract"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{
      $t('Context.short.extract')
    }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import FeatureDetectorService from '@/services/FeatureDetector/FeatureDetectorService';

import AppConstantsUtil from '@/services/utils/AppConstantsUtil';
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('ExtractControl.vue');

export default {
  name: 'ExtractControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    isGuest() {
      return this.$store.getters['UserStore/isGuestUser'];
    },
    isDisabledIconInAttr() {
      return this.$attrs['icon-disabled'];
    },
    isIconDisabled() {
      return this.isDisabledIconInAttr || this.isGuest;
    }
  },
  methods: {
    async openCreateCompilationPopup() {
      const { indexDB } = await FeatureDetectorService.getDetections();
      if (indexDB) {
        this.$_addSelectionToCompilation();
      } else {
        this.$store.dispatch('ManagePopupStore/openUsageSuggestionPopup');
      }
    },
    createCompilationHandler() {
      if (this.isDisabledIconInAttr && !this.isGuest) {
        this.$store.dispatch('ManagePopupStore/openToaster', {
          text: this.$t('CompilationControl.toaster.disabled.message', {
            paraNum: AppConstantsUtil.MAX_SELECTION_PARAS_NUMBER
          }),
          toasterClose: false
        });
        return;
      }

      this.$store.dispatch('PaymentsStore/wrappWithGuestLogic', {
        handler: this.openCreateCompilationPopup
      });
    },

    async $_addSelectionToCompilation() {
      try {
        const selection = await this.$store.dispatch(
          'PublicationStore/buildCompilationSelectionFromLocator',
          {
            locator: this.selectedLocator,
            bookId: this.bookId
          }
        );
        if (!selection) {
          return;
        }

        this.$store.dispatch('CompilationsStore/addSelectionToCompilation', {
          selection
        });
      } catch (error) {
        const text = this.$t('ExtractControl.buildSelection.error.message');
        this.$store.dispatch('ManagePopupStore/openErrorToaster', { text });
        logger.error(
          `Add selection to compilation failed with error: ${error}`
        );
      }
    }
  }
};
</script>
